import { createContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import "../i18n/i18n";

const i18nContext = createContext({});

export const I18nProvider = ({ children }: any) => {
	const { i18n } = useTranslation();
	const [searchParams] = useSearchParams();
	document.body.dir = i18n.dir();

	useEffect(() => {
		const lang = searchParams.get("lang");
		if (lang) {
			i18n.changeLanguage(lang);
			document.body.dir = i18n.dir();
		}
	}, [searchParams, i18n]);

	return <i18nContext.Provider value={{}}>{children}</i18nContext.Provider>;
};
